module.exports = __webpack_public_path__ + "img/Default.f5c8f7df.svg";